import React, { Component } from 'react';
import { IonBadge, IonHeader, IonButton, IonButtons, IonToolbar,
  IonSelectOption, IonContent, IonList, IonItem, IonLabel, IonCheckbox,
} from '@ionic/react';
import states from '../jsons/states.json';

type Props = {
  refocus: boolean,
  dismissModal: () => void;
  selectedFilters: string[];
  updateFilter: (filter: string[], refocus: boolean) => void;
}

type State = {
  selected: string[],
  visited: boolean,
  favorites: boolean,
  bucket: boolean,
  refocus: boolean,
  all: boolean,
}

export default class MapFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ...this.state,
      refocus: props.refocus,
      visited: props.selectedFilters.includes('visited'),
      favorites: props.selectedFilters.includes('favorites'),
      bucket: props.selectedFilters.includes('bucket'),
      all: props.selectedFilters.includes('all'),
      selected: props.selectedFilters,
    }
  }

  stateSelected = (e: CustomEvent) => {
    this.setState({
      ...this.state,
      selected: e.detail.value,
    });
  }

  resetFilters = () => {
    this.setState({
      ...this.state,
      visited: this.props.selectedFilters.includes('visited'),
      favorites: this.props.selectedFilters.includes('favorites'),
      bucket: this.props.selectedFilters.includes('bucket'),
      all: this.props.selectedFilters.includes('all'),
      refocus: this.props.refocus,
    });
    this.props.dismissModal();
  }

  applyFilters = () => {
    const visitedChecked = this.state.visited;
    const favoriteChecked = this.state.favorites;
    const bucketChecked = this.state.bucket;
    const allChecked = this.state.all;
    if (allChecked) {
      this.props.updateFilter(['all'], this.state.refocus);
      this.props.dismissModal();
      return
    }
    const selected = [];
    if (visitedChecked) {
      selected.push('visited');
    }
    if (favoriteChecked) {
      selected.push('favorites');
    }
    if (bucketChecked) {
      selected.push('bucket');
    }
    this.props.updateFilter(selected, this.state.refocus);
    this.props.dismissModal();
  }
  
  handleToggle = (e: CustomEvent, attribute: string) => {
    if (attribute === 'refocus') {
      this.setState({
        ...this.state,
        // @ts-ignore
        refocus: e!.target!.checked,
      });
      return;
    }
    if (attribute === 'all') {
      this.setState({
        ...this.state,
        // @ts-ignore
        visited: e!.target!.checked,
        // @ts-ignore
        favorites: e!.target!.checked,
        // @ts-ignore
        bucket: e!.target!.checked,
        // @ts-ignore
        all: e!.target!.checked,
      });
      return;
    }
    this.setState({
      ...this.state,
      // @ts-ignore
      [attribute]: e!.target!.checked,
      all: false,
    });
  }
  render() {
    const { all, visited, favorites, bucket, refocus } = this.state;
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={this.resetFilters}>Cancel</IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={this.applyFilters} strong>Save</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent class="outer-content">
          <IonList>
            {/* <IonSelect
              onIonChange={this.stateSelected}
              value={this.state.selected}
              selectedText="Select Item"
              placeholder="Select State"
              multiple={true}
              cancelText="Cancel"
              okText="Confirm">
            { ['Visited', 'Favorites', 'Bucket'].map((key: string, index: number) => (
              <IonSelectOption key={key} value={key.toLowerCase()}>{key} </IonSelectOption>
            ))}
            </IonSelect>
            <IonItem style={ isAnySelected ? {} : {display: 'none'} }>
              <div>
              { this.state.selected.map((item: any, index: number) => (
                <IonBadge key={`badge${item}`} style={{'margin': '5px'}} color="medium"> {item} </IonBadge>
              ))}
              </div>
            </IonItem> */}
            <IonItem>
              <IonLabel>Refocus Map</IonLabel>
              <IonCheckbox onClick={(e: any) => this.handleToggle(e, 'refocus')} checked={refocus} color="primary" />
            </IonItem>
            <IonItem>
              <IonLabel>All</IonLabel>
              <IonCheckbox onClick={(e: any) => this.handleToggle(e, 'all')} checked={all} color="primary" />
            </IonItem>
            <IonItem>
              <IonLabel>Visited</IonLabel>
              <IonCheckbox onClick={(e: any) => this.handleToggle(e, 'visited')} checked={visited} color="primary" />
            </IonItem>
            <IonItem>
              <IonLabel>Favorites</IonLabel>
              <IonCheckbox onClick={(e: any) => this.handleToggle(e, 'favorites')} checked={favorites} color="primary" />
            </IonItem>
            <IonItem>
              <IonLabel>Bucket</IonLabel>
              <IonCheckbox onClick={(e: any) => this.handleToggle(e, 'bucket')} checked={bucket} color="primary" />
            </IonItem>
          </IonList>
          <IonList>
            <IonItem onClick={this.resetFilters} detail={false} class="reset-filters">
              <IonButton>Reset</IonButton>
            </IonItem>
          </IonList>
        </IonContent>
      </>
    );
  }
}
